module.exports = __webpack_public_path__ + "img/Reportgray.5a7ed76a.svg";